import { useState, useEffect } from 'react';
import { subscribe } from 'app/helpers/cable';

export type Bonus = {
  amount: number | null;
  status: string | null;
};

const useBonus = (amount: Bonus['amount'], status: Bonus['status']): Bonus => {
  const [bonus, setBonus] = useState<Bonus>({ amount, status });

  useEffect(() => {
    const { unsubscribe } = subscribe(
      {
        channel: 'FreebetBonusesChannel',
      },
      {
        received: setBonus,
      }
    );

    return () => {
      unsubscribe();
    };
  }, []);

  return bonus;
};

export default useBonus;
